export enum DisplayNameFormat {
  FIRST_L = 'FIRST_L',
  LAST_F = 'LAST_F',
  FIRST_LAST = 'FIRST_LAST',
  LAST_FIRST = 'LAST_FIRST',
  F_LAST = 'F_LAST',
  L_FIRST = 'L_FIRST',
}

export namespace DisplayNameFormat {
  export enum Index {
    FIRST_L = 0,
    LAST_F = 1,
    FIRST_LAST = 2,
    LAST_FIRST = 3,
    F_LAST = 4,
    L_FIRST = 5,
  }

  export function ensureIndex(index: number) {
    switch (index) {
      case Index.FIRST_L:
      case Index.LAST_F:
      case Index.FIRST_LAST:
      case Index.LAST_FIRST:
      case Index.F_LAST:
      case Index.L_FIRST:
        return <Index>index;
    }

    throw new Error('Invalid display name format index: ' + index);
  }

  export function fromIndex(index: DisplayNameFormat.Index) {
    switch (index) {
      case Index.FIRST_L:
        return DisplayNameFormat.FIRST_L;
      case Index.LAST_F:
        return DisplayNameFormat.LAST_F;
      case Index.FIRST_LAST:
        return DisplayNameFormat.FIRST_LAST;
      case Index.LAST_FIRST:
        return DisplayNameFormat.LAST_FIRST;
      case Index.F_LAST:
        return DisplayNameFormat.F_LAST;
      case Index.L_FIRST:
        return DisplayNameFormat.L_FIRST;
      default:
        // TODO: Pass in logger
        console.warn('DisplayNameFormat.fromIndex() unknown index ' + index + ' defaulting to FIRST_L');
        return DisplayNameFormat.FIRST_L;
    }
  }

  export function toIndex(format: DisplayNameFormat) {
    switch (format) {
      case DisplayNameFormat.FIRST_L:
        return Index.FIRST_L;
      case DisplayNameFormat.LAST_F:
        return Index.LAST_F;
      case DisplayNameFormat.FIRST_LAST:
        return Index.FIRST_LAST;
      case DisplayNameFormat.LAST_FIRST:
        return Index.LAST_FIRST;
      case DisplayNameFormat.F_LAST:
        return Index.F_LAST;
      case DisplayNameFormat.L_FIRST:
        return Index.L_FIRST;
      default:
        // TODO: Pass in logger
        console.warn('DisplayNameFormat.toIndex() unknown format ' + format + ' defaulting to FIRST_L');
        return Index.FIRST_L;
    }
  }

  /**
   * If there are multiple word boundaries within the first and/or the last name, each word will
   * be capitalized (camel case).
   */
  export function format(first: string, last: string, format: DisplayNameFormat): string {
    const cleanAndFormat = (value: string): string | undefined => {
      if (value === undefined || value === null || value === '') {
        return undefined;
      } else {
        return value
          .trim()
          .replace(/\w+/g, (word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
      }
    };

    const formattedFirst = cleanAndFormat(first);
    const formattedLast = cleanAndFormat(last);
    const firstLetter = (value: string | undefined) => value && value.charAt(0);

    const nameOrder = () => {
      switch (format) {
        case DisplayNameFormat.FIRST_L:
          return [formattedFirst, firstLetter(formattedLast)];
        case DisplayNameFormat.FIRST_LAST:
          return [formattedFirst, formattedLast];
        case DisplayNameFormat.LAST_F:
          return [formattedLast, firstLetter(formattedFirst)];
        case DisplayNameFormat.LAST_FIRST:
          return [formattedLast, formattedFirst];
        case DisplayNameFormat.F_LAST:
          return [firstLetter(formattedFirst), formattedLast];
        case DisplayNameFormat.L_FIRST:
          return [firstLetter(formattedLast), formattedFirst];
        default:
          // TODO: Pass in logger
          console.warn(`DisplayNameFormat.format unknown format (${format}) defaulting to FIRST_L`);
          return [formattedFirst, firstLetter(formattedLast)];
      }
    };

    return nameOrder()
      .filter(i => i !== undefined && i.length > 0)
      .join(' ');
  }
}
